export default "__VITE_ASSET__DT80ytEx__"